import { tableFeatures, metaHelper, rowSortingFeature, createSortedRowModel, sortFn_datetime, sortFn_alphanumeric, sortFn_text, columnFilteringFeature, createFilteredRowModel, filterFn_includesString, filterFn_inNumberRange, filterFn_inDateRange, filterFn_equals, filterFn_arrIncludes, filterFn_weakEquals, filterFn_equalsStringSensitive, globalFilteringFeature, columnVisibilityFeature, columnSizingFeature, rowSelectionFeature, rowPaginationFeature, createPaginatedRowModel, rowExpandingFeature, createExpandedRowModel, columnGroupingFeature, createGroupedRowModel } from "@tanstack/react-table";
export const dataTableFeatures = tableFeatures({
    rowSortingFeature,
    sortedRowModel: createSortedRowModel(),
    sortFns: {
        datetime: sortFn_datetime,
        alphanumeric: sortFn_alphanumeric,
        text: sortFn_text
    },
    columnFilteringFeature,
    filteredRowModel: createFilteredRowModel(),
    filterFns: {
        includesString: filterFn_includesString,
        inNumberRange: filterFn_inNumberRange,
        inDateRange: filterFn_inDateRange,
        equals: filterFn_equals,
        arrIncludes: filterFn_arrIncludes,
        weakEquals: filterFn_weakEquals,
        equalsStringSensitive: filterFn_equalsStringSensitive
    },
    globalFilteringFeature,
    columnVisibilityFeature,
    columnSizingFeature,
    rowSelectionFeature,
    rowPaginationFeature,
    paginatedRowModel: createPaginatedRowModel(),
    rowExpandingFeature,
    expandedRowModel: createExpandedRowModel(),
    columnGroupingFeature,
    groupedRowModel: createGroupedRowModel(),
    columnMeta: metaHelper()
});

//# sourceMappingURL=features.js.map